// Async feature bundle for motion's LazyMotion. Components that ship in the
// shared entry chunk (the persistent layout tree: SiteHeader, SiteLogoMark)
// must use `m.*` from motion/react instead of `motion.*` — the full `motion`
// component statically drags every animation feature (~150 kB minified) into
// the critical JS parsed on every page. LazyMotion mounts in
// PersistentLayout, starts this import immediately, and feeds the features to
// `m` components when it lands; page-chunk components are already code-split
// per route and may keep using full `motion`.
//
// domMax (not domAnimation) because the header's nav pill animates via
// `layoutId`, which needs the layout-projection features.
export const loadMotionFeatures = () =>
  import("motion/react").then((mod) => mod.domMax)
